import { useFormContext } from "react-hook-form";
import { Button } from "@moneyforward/mfx_biz_react_components";
import {
  passwordValidation,
  usernameValidation,
} from "@/components/validations";
import React from "react";
import {
  EmailLabel,
  KanaNameFormField,
  NameFormField,
  PasswordFormField,
  UsernameFormField,
} from "@/components/molecules";
import { css } from "@emotion/react";
import { color } from "@/styles/theme";
import { useIsSpMode } from "@/hooks";

type FormValues = {
  username: string;
  companyName: string;
  email: string;
  password: string;
  lastName: string;
  lastNameKana: string;
  middleName: string;
  middleNameKana: string;
  firstName: string;
  firstNameKana: string;
};

type Props = {
  email: string;
  onSubmit?: ({ password }: FormValues) => void;
};

export const RegisterCompanyForm = ({ email, onSubmit }: Props) => {
  const isSpMode = useIsSpMode();
  const { handleSubmit, formState } = useFormContext();

  return (
    <div css={container}>
      <div css={!isSpMode ? box : spModeBox}>
        <form onSubmit={handleSubmit(onSubmit)} css={form}>
          <div css={!isSpMode ? inputList : spModeInputList}>
            <div css={listItem}>
              <NameFormField
                nameLastName="lastName"
                nameFirstName="firstName"
              />
            </div>
            <div css={listItem}>
              <KanaNameFormField
                nameLastName="lastNameKana"
                nameFirstName="firstNameKana"
              />
            </div>
          </div>
          <div css={listItem}>
            <EmailLabel email={email} />
          </div>
          <div css={{ border: "1px solid #DADEDF", margin: "10px 0 20px 0" }} />
          <div css={listItem}>
            <UsernameFormField
              name="username"
              whetherToDisplayTheValidationRule={true}
              validate={usernameValidation}
              requiredLabel={true}
            />
          </div>
          <div css={listItem}>
            <PasswordFormField
              name="password"
              usePasswordMeter={true}
              requiredLabel={true}
              registerOptions={{
                validate: passwordValidation,
              }}
            />
          </div>
          <div css={buttonWrapper}>
            <Button
              type="submit"
              variant="primary"
              disabled={formState.isSubmitting}
            >
              登録
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  justifyContent: "center",
});

const box = css({
  width: "640px",
  minHeight: "245px",
  padding: "32px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const spModeBox = css({
  width: "640px",
  minHeight: "245px",
  padding: "15px 17px",
  border: `1px solid ${color.iron}`,
  borderRadius: "4px",
});

const form = css({
  width: "100%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
});

const inputList = css({
  flex: 1,
});

const spModeInputList = css({
  flex: 1,
});

const listItem = css({
  marginBottom: "24px",
});

const buttonWrapper = css({
  display: "flex",
  justifyContent: "flex-end",
});
